<template>
    <div>
      <div class="col-lg-12">
        <button class="btn btn-xs btn-primary pull-right" data-toggle="modal" data-target="#add-notes"><i class="fa fa-plus m-r-xs"></i>Add Note</button>
        <notes-modal :targetId="this.$route.params.id" :targetType="'projects'"></notes-modal>
      </div>
      <notes-logs :notes="projectNotes"></notes-logs>
    </div>
</template>
<script>
import axios from 'axios'
import { eventBus } from '../../../../../../../main'
import NotesLogs from '../../../../../../Helpers/Tabs/NotesLogs.vue'
import NotesModal from '../../../../../../Helpers/Modal/NotesModal.vue'

export default {
  data () {
    return {
      projectNotes: []
    }
  },
  mounted () {
    this.getNotes()

    eventBus.$on('loadNotes', () => {
      this.getNotes()
    })
  },
  components: {
    notesLogs: NotesLogs,
    notesModal: NotesModal
  },
  methods: {
    async getNotes () {
      try {
        let r = await axios.get(`/v2/messages?type=note&targets[type]=projects&targets[id]=${this.$route.params.id}`)
        this.projectNotes = r.data
      } catch (error) {
        this.$toastr.error('Failed to load project history', error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/TaskManager/Projects/Single/Content/Tabs/ProjectNotes.vue